export const webshop = {
  seo: {
    title: 'Online webshop for restaurants & hospitality – Takeaway & delivery | Bistroo',
    description: 'A personalised webshop for your restaurant or hospitality business, fully customisable to your wishes. Try free for 30 days.',
  },
  hero: {
    title: {
      pt1: 'A',
      pt2: 'webshop',
      pt3: 'tailor-made for restaurants',
    },
    description:
      "Make it easy for yourself with the Bistroo webshop. Our customers save time, work more efficiently and see their revenue grow.",
  },
  paragraphs: {
    paragraph_1: {
      title: 'Increase your revenue, reduce your costs',
      text: 'A well-optimized webshop can generate more orders and higher average order values compared to traditional ordering methods. Save up to 20% in operational costs and time, and handle more orders than ever before effortlessly.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_2: {
      title: 'Pay only once you\'ve tasted the value',
      text: 'From completely free packages to accessible monthly subscriptions, choose the pricing plan that suits your taste and discover for yourself what Bistroo\'s products can do for you. With a free trial period you can easily try it out without being locked into a contract.',
      cta: '',
    },
    paragraph_3: {
      title: 'Order via Google',
      text: 'We literally put you on the map. We optimize your webshop for Google Search and Google Maps. We follow innovations in online traffic and ensure your webshop stays easy to find. This option is included in all Bistroo packages.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_4: {
      title: 'Customize to your brand',
      text: "A complete white-label package is available, letting you shape the entire customer experience in your restaurant's style. From the landing page to the ordering and confirmation process. Everything in your unique style.",
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Process orders effortlessly.',
        text: 'Manage every order to perfection, anywhere and at any time, from any device. Print receipts the way you want, on any type of printer.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Integrations.',
        text: 'Connect your favorite POS system or external tools.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Upselling options.',
        text: 'Set up extensive upsell options and increase the average order value of your orders.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Grow your revenue.',
        text: 'Up to 30% more revenue with an optimized webshop.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Discounts and loyalty.',
        text: 'Set up promotions, discounts and loyalty rewards for your returning customers.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Since working with Bistroo, we\'ve seen our to-go orders go up consistently — great! And whenever something isn\'t right, Bistroo is easy to reach and solves it immediately."',
    cta: 'Read the full story',
    name: 'Marieke van Loon',
    job_title: 'Owner Xtra-social',
  },
  faq: {
    title_pt1: 'All about the',
    title_pt2: 'Bistroo Webshop',
    items: [
      { q: 'How do I create a Bistroo webshop?', a: 'Register for free at merchant.bistroo.nl. After signing up you go through a short setup where you enter your menu, opening hours and delivery areas. Within minutes your webshop is live.' },
      { q: 'Can I set up the webshop fully in my own branding?', a: 'Yes. You choose your own colors, upload your logo and profile photo and set a welcome message. Want to go all the way? With the white-label package you control the entire customer experience in your brand style, from the landing page to the order confirmation.' },
      { q: 'Which payment methods can my customers use?', a: 'Via Bistroo, customers can pay with iDEAL, credit card, Apple Pay, Google Pay and more. You connect your own payment provider (Mollie or Stripe) and payments land directly in your account.' },
      { q: 'How do I get found via Google?', a: 'Bistroo optimizes your webshop for Google Search and Google Maps. Via Order with Google an order button also appears directly in search results, so customers can order from you without any detours.' },
      { q: 'Can I set up discounts and loyalty promotions?', a: 'Yes. In the Bistroo Manager you easily set up discount codes, temporary promotions and loyalty rewards. These are immediately visible in your webshop.' },
      { q: 'Can the webshop be connected to my POS system?', a: 'Yes. Bistroo integrates with the most widely used POS systems such as Lightspeed, unTill, M+ Kassa, WinstonPOS and Cashdesk. Orders automatically arrive as tickets in your till.' },
      { q: 'How do I set up my delivery and pickup areas?', a: 'Via the Bistroo Manager you draw your delivery areas precisely on Google Maps. Per zone you set separate delivery costs and minimum order amounts. Changes go live immediately.' },
      { q: 'What does the Bistroo webshop cost?', a: 'Bistroo has a free package so you can start right away. For more features there are paid monthly packages available. There are no setup costs and no long-term contracts.' },
      { q: 'Can I manage multiple locations from one account?', a: 'Yes. Via the Bistroo Manager you manage all your venues centrally. Per location you configure separate menus, opening hours and delivery areas.' },
      { q: 'How long does it take to get my webshop live?', a: 'For most restaurants the webshop is operational within a day. Bistroo offers onboarding support so you get started quickly and without errors.' },
    ],
  },
}
